var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetworking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.8 7.5625H0.7C0.313469 7.5625 0 7.87037 0 8.25V10.3125C0 10.6921 0.313469 11 0.7 11H2.8C3.18653 11 3.5 10.6921 3.5 10.3125V8.25C3.5 7.87037 3.18653 7.5625 2.8 7.5625ZM2.275 5.84375H6.475V6.875H7.525V5.84375H11.725V6.875H12.775V5.63771C12.775 5.18289 12.3981 4.8125 11.9348 4.8125H7.525V3.4375H8.4C8.78653 3.4375 9.1 3.12963 9.1 2.75V0.6875C9.1 0.307871 8.78653 0 8.4 0H5.6C5.21347 0 4.9 0.307871 4.9 0.6875V2.75C4.9 3.12963 5.21347 3.4375 5.6 3.4375H6.475V4.8125H2.06522C1.60191 4.8125 1.225 5.18268 1.225 5.63771V6.875H2.275V5.84375ZM8.05 7.5625H5.95C5.56347 7.5625 5.25 7.87037 5.25 8.25V10.3125C5.25 10.6921 5.56347 11 5.95 11H8.05C8.43653 11 8.75 10.6921 8.75 10.3125V8.25C8.75 7.87037 8.43653 7.5625 8.05 7.5625ZM13.3 7.5625H11.2C10.8135 7.5625 10.5 7.87037 10.5 8.25V10.3125C10.5 10.6921 10.8135 11 11.2 11H13.3C13.6865 11 14 10.6921 14 10.3125V8.25C14 7.87037 13.6865 7.5625 13.3 7.5625Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworking);
export default __webpack_public_path__ + "static/media/networking.0a508016f2398316d19f43b87d2b6727.svg";
export { ForwardRef as ReactComponent };